// tokenProvider.ts
let tokenGetter: () => Promise<string | null> = async () => null;

export const setTokenGetter = (getter: () => Promise<string | null>) => {
  tokenGetter = getter;
};

export const getToken = async () => {
  return await tokenGetter();
};
